import React, { useState, useEffect, useRef } from 'react'
import CreatableSelect from "react-select/creatable";
import { getPersons } from "api/AccountsApi"
import { getAllUsers } from "api/UsersApi"
import { getTasksById } from "api/SalesApi"
import { useSelector } from 'react-redux';
import "views/Accounts/PersonDetails/style.css"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import moment from 'moment';
import $ from 'jquery'
import { postMeeting, getMeetings, putMeeting } from "./Api"
import { toast } from "react-toastify";


const createOption = (label) => ({
    label,
    value: null,
});
export default function CreateTaskModal({ refresh, meeting, editTask, taskId, endDate, startDate }) {
    const [change, setChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [reminderCustomDate, setReminderCustomDate] = useState(false)
    const [reminderCustomDateValue, setReminderCustomDateValue] = useState(null)
    const [taskReminder, setTaskReminder] = useState('No reminder')
    const [persons, setPersons] = useState([]);

    const [attendees, setAttendees] = useState([]);
    const [onEdit, setOnEdit] = useState(false);

    const titleRef = useRef("");
    const typeRef = useRef("");
    const startDateRef = useRef("");
    const noteRef = useRef("");
    const description = useRef("");
    const endDateRef = useRef("");

    const whereRef = useRef("");

    $('#createMeeting').on('hidden.bs.modal', function () {
        // do something…
        try {
            //reset();
        } catch (e) { }
    });
    useEffect(() => {
        $('.rbc-time-slot').toArray().forEach((elem) => { elem.title = 'click me'; });
    }, [])
    useEffect(() => {
        if(!meeting){
            startDateRef.current.value = startDate
            endDateRef.current.value = endDate  
        }
 
      
    })
     useEffect(() => {
         reset();      
        startDateRef.current.value = startDate
        endDateRef.current.value = endDate

        getPersons(50, 0, "").then(users => {
            users = users.map(u => { return { label: (u.firstName + " " + u.lastName + `\n<${u.email}>`), value: u.id } })
           console.log(users)
            setPersons(users)
        })

        if (meeting) {
            let att = meeting.persons.map(u => { return { label: (u.firstName + " " + u.lastName + `\n<${u.email}>`), value: u.id } })
            if(meeting.guestAttendees && meeting.guestAttendees.length)
                att = [...att, ...meeting.guestAttendees.map(u => { return { label: u, value: null } })]
            setAttendees(att);

            titleRef.current.value = meeting.title
            startDateRef.current.value = moment(meeting.startDateTime).format('YYYY-MM-DDTHH:mm:ss')
            endDateRef.current.value = moment(meeting.endDateTime).format('YYYY-MM-DDTHH:mm:ss')

            noteRef.current.value = meeting.text
            description.current.value = meeting.description
            typeRef.current.value = meeting.type
            whereRef.current.value = meeting.where
            setTaskReminder(meeting.reminderType)
            if (meeting.reminderType == 'Custom Date') {
                setReminderCustomDateValue(moment(meeting.reminderDateTime).format('YYYY-MM-DDTHH:mm:ss'))
                setReminderCustomDate(true)
            }

            setOnEdit(true)

        } else { setOnEdit(false) }

    }, [meeting, startDate, endDate])
    const reset = () => {
        titleRef.current.value = ''
        startDateRef.current.value = ''
        noteRef.current.value = ''
        description.current.value = ''
        endDateRef.current.value = ''
        typeRef.current.value = ''
        whereRef.current.value = ''
        setReminderCustomDate(false)
        setTaskReminder('No reminder')
        setAttendees([])
        console.log('reset')
    }



    const createTask = () => {
        if (endDateRef.current.value <= startDateRef.current.value ){
            toast.info("Meeting end date can't precede it's start");
            return
        }
        let data = {
            title: titleRef.current.value,
            text: noteRef.current.value,
            type: typeRef.current.value,
            description: description.current.value,
            startDateTime: new Date(startDateRef.current.value),
            endDateTime: new Date(endDateRef.current.value),
            persons: attendees.filter(a => a.value != null).map(a => a.value),
            guestAttendees: attendees.filter(a => a.value == null).map(a => a.label),
            reminderType: taskReminder,
            where: whereRef.current.value,
            reminderDateTime: new Date(reminderCustomDateValue) ,

        }
        postMeeting(data).then((response) => {
            refresh()
            $('#createMeeting').modal('hide');
            toast.success("Meeting has been created successfully.");
            reset()


        }).catch(e => {
            toast.error("something went wrong on server side");
            reset()

        })

    }
    const updateTask = () => {
        if (endDateRef.current.value <= startDateRef.current.value) {
            toast.info("Meeting end date can't precede it's start");
            return
        }
        let data = {
            title: titleRef.current.value,
            text: noteRef.current.value,
            type: typeRef.current.value,
            description: description.current.value,
            startDateTime: new Date(startDateRef.current.value),
            endDateTime: new Date(endDateRef.current.value),
            persons: attendees.filter(a => a.value != null).map(a => a.value),
            guestAttendees: attendees.filter(a => a.value == null).map(a => a.label),
            reminderType: taskReminder,
            where: whereRef.current.value,
            reminderDateTime: new Date(reminderCustomDateValue),

        }
        putMeeting(data, meeting.id).then((response) => {
            refresh()
            $('#createMeeting').modal('hide');
            toast.success("Meeting has been saved successfully.");
            reset()



        }).catch(e => {
            toast.error("something went wrong on server side");
            reset()

        })

    }

    const handleInputChange = (inputValue, actionMeta) => {
        if (inputValue) {
            getPersons(100, 0, inputValue).then(users => {
                users = users.map(u => { return { label: (u.firstName + " " + u.lastName + `\n<${u.email}>`), value: u.id } })
                setPersons(users)

            })
        }
    };


    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            //  padding: '2px 8px',
            //  backgroundColor: "red",
            outline: 'none',
            outline: 'none',
            paddingTop: 0,
            marginTop: 0,
            padding: '17px',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            //    padding: '2px 8px',
            //  backgroundColor: "red",
            outline: 'none',
            paddingBottom: '6px'
        }),
        control: base => ({
            ...base,
            border: "1px solid rgb(118, 118, 118)",
            boxShadow: 'none',
            paddingTop: '2px'

        })

    }
    const handleChange = (newValue, actionMeta) => {
        setChange(true);
        setAttendees(newValue);
    };
    const handleCreate = (inputValue) => {
        setChange(true);
        setIsLoading(true);
        setTimeout(() => {
            const newOption = createOption(inputValue);
            setAttendees([...attendees, newOption]);
            setIsLoading(false);
        }, 1000);
    };


    return (
        <div class="modal fade create-task-modal"
            id='createMeeting'>
            <div class="modal-dialog kw_md">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">{onEdit ? 'Edit' : 'Create'} Meeting</div>
                        <span class="icon-Group-240" data-dismiss="modal">  </span>
                    </div>
                    <form onSubmit={(e) => {
                        e.preventDefault();

                        if (onEdit)
                            updateTask()
                        else
                            createTask()



                    }}>
                        <div class="modal-body">
                            <div className='row'>
                                <div className='col-12 task-modal-input'>
                                    <label for="task_title" >
                                        Meeting Title
                                    </label>
                                    <input
                                        required
                                        type="text"
                                        id="task_title"
                                        className=' kwDesign w-100'
                                        ref={titleRef}
                                    />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 task-modal-input'>

                                    <label for="task_duedate"  >
                                        Start Time
                                    </label>
                                    <input
                                        required
                                        id="task_duedate"
                                        type="datetime-local"
                                        className="kwDesign w-100"
                                        ref={startDateRef}
                                    />

                                </div>

                                <div className='col-6 task-modal-input'>

                                    <label for="task_duedate"  >
                                        End Time
                                    </label>
                                    {console.log("mimmm",moment(new Date(startDateRef.current.value)).format('YYYY-MM-DDTHH:mm:ss'))}
                                    <input
                                        required
                                        id="task_duedate"
                                        type="datetime-local"
                                        className="kwDesign w-100"

                                        // onChange={(e) => {
                                        //     console.log(endDateRef.current.value)
                                        //    // endDate = e.target.value;
                                        //     if (endDateRef.current.value < startDateRef.current.value){
                                        //         toast.error("meeting's end date can't precede it's start date")
                                        //         endDateRef.current.value = startDateRef.current.value
                                        //     }
                                        // }}



                                        ref={endDateRef}
                                    />

                                </div>



                            </div>
                            <div className='row'>
                                <div className='col-12 task-modal-input'>
                                    <label for="task_title" >
                                        Where
                                    </label>
                                    <input
                                        type="text"
                                        id="task_title"
                                        className=' kwDesign w-100'
                                        ref={whereRef}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 task-modal-input'>
                                    <label for="task_title" >
                                        Description
                                    </label>
                                    <textarea
                                        type="text"
                                        id="task_title"
                                        className='kwDesign w-100'
                                        ref={description}
                                    />

                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 task-modal-input'>
                                    <label for="task_title" >
                                        Attendees
                                    </label>


                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        onInputChange={handleInputChange}
                                        value={attendees}
                                        onChange={handleChange}
                                        onCreateOption={handleCreate}
                                        placeholder={'search..'}

                                        styles={customStyles}

                                        options={persons}


                                    />
                                </div>

                                <div className='col-6 task-modal-input'>
                                    <label for="task_title"  >
                                        Type
                                    </label>
                                    <select
                                        type="text"
                                        id="task_title"
                                        className=' kwDesign2 w-100'
                                        ref={typeRef}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="email">Email</option>
                                        <option value="call">Call</option>
                                        <option value="todo">Todo</option>
                                    </select>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 task-modal-input'>
                                    <label for="task_title"  >
                                        Reminder
                                    </label>
                                    <select
                                        id="task_title"
                                        className='kwDesign2 w-100'
                                        onChange={(e) => {
                                            if (e.target.value === 'Custom Date') {
                                                setReminderCustomDate(true)
                                            } else {
                                                setReminderCustomDate(false)
                                            }
                                            setTaskReminder(e.target.value)
                                        }}
                                        value={taskReminder}
                                    //ref={taskReminderRef}
                                    >
                                        <option value="No reminder">No reminder</option>
                                        <option value="At task due time">At Meeting start time</option>
                                        <option value="30 minutes before">30 minutes before</option>
                                        <option value="1 hour before">1 hour before </option>
                                        <option value="1 day before">1 day before</option>
                                        <option value="1 week before">1 week before</option>
                                        <option value="Custom Date">Custom Date</option>
                                    </select>
                                </div>
                                {
                                    reminderCustomDate && <div className='col-6 task-modal-input'>
                                        <label for="task_duedate"  >
                                            Reminder Date
                                        </label>
                                        <input
                                            id="task_duedate"
                                            type="datetime-local"
                                            className="kwDesign w-100"
                                            onChange={(e) => {
                                                let date = moment(new Date(e.target.value)).format('YYYY-MM-DDTHH:mm:ss')
                                                setReminderCustomDateValue(date)
                                            }}
                                            value={reminderCustomDateValue}
                                        />
                                    </div>
                                }
                            </div>
                            <div className='row'>
                                <div className='col-12 task-modal-input'>
                                    <label for="task_title" >
                                        Notes
                                    </label>
                                    <textarea
                                        type="text"
                                        id="task_title"
                                        className='kwDesign w-100'
                                        ref={noteRef}
                                    />

                                </div>
                            </div>

                            <div class="footerBtn d-flex justify-content-center align-items-center mt-4">
                                <input
                                    type="submit"
                                    className="lg_btn primary m-2"
                                    value={onEdit ? "Save" : "Create"}
                                    id="finalize"

                                />

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    )
}
